import { useFetch } from "hooks/api";
import { useAppSelector } from "redux/hooks";

export const useAMCQueryData = () => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const { data, isLoading } = useFetch(
    ["subscribedAMCQueries"],
    "/amc/subscriptions",
    {
      marketplace: marketPlace,
    },
    {
      select: (res) => {
        return res.data.results ?? [];
      },
      default: [],
    },
  );

  return { data, isLoading };
};
